import { ObservationsV1IssuePriorityLevel } from '@spotify/confidence-graphql';

import { getIssuePriorityLabel } from '../../types';
import { IssuePriorityIcon } from './IssuePriorityIcon';

import styles from './IssuePriorityColoredIcon.module.css';

type PriorityIconTone = 'negative' | 'warning';

const PRIORITY_ICON_TONES: Partial<
  Record<ObservationsV1IssuePriorityLevel, PriorityIconTone>
> = {
  [ObservationsV1IssuePriorityLevel.Critical]: 'negative',
  [ObservationsV1IssuePriorityLevel.High]: 'warning',
  [ObservationsV1IssuePriorityLevel.Medium]: 'warning',
};

export type IssuePriorityColoredIconProps = {
  priority?: ObservationsV1IssuePriorityLevel | null;
};

export const IssuePriorityColoredIcon = ({
  priority,
}: IssuePriorityColoredIconProps) => {
  const label = priority
    ? `${getIssuePriorityLabel(priority)} priority`
    : 'No priority';

  return (
    <span
      className={styles.root}
      data-tone={priority ? PRIORITY_ICON_TONES[priority] : undefined}
      role="img"
      aria-label={label}
      title={label}
    >
      <IssuePriorityIcon priority={priority} />
    </span>
  );
};
